import React from "react";
import { arrowLeft, dotss } from "../../../assets";
import AvatarImage from "./../../avatarImage";
import { Link } from "react-router-dom";
import MassageMe from "./MassageMe";
import MassageYou from "./MassageYou";
import chemistrys from './../../../assets/image/chemistry.jpg' 

const Chat = () => {
  const useractive = true;
  return (
    <>
      <div className="flex mx-[25px] md:mx-[100px] bg-white z-50 fixed w-full py-[15 px] sm:pt-[20px] items-center gap-[25px] sm:gap-[40px]">
        <Link to="/message">
          <img src={arrowLeft} alt="" />
        </Link>
        <div className="flex w-full items-center gap-[10px]">
          <div className="w-[40px] relative sm:w-[45px] sm:h-[50px] h-[40px]">
            {useractive && (
              <div className="h-[10px] w-[10px] sm:border-[2px] absolute z-10 top-0 bg-blue-chatBlue rounded-[50%] border-white border-solid border-[3px] right-0 box-content sm:w-[10px] sm:h-[10px]"></div>
            )}
            <AvatarImage style={`h-[40px] sm:w-[50px] sm:h-[50px] w-[40px] `} />
          </div>
          <div className="flex w-full justify-between items-center">
            <div>
              <div className="font-[700] text-[16px]">User Name</div>
              <div className="text-gray-lightGray text-[16px]">Online</div>
            </div>
            <div>
              <img src={dotss} alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-[100px] ">
        <div className="flex flex-col items-center ">
          <div className="w-[75px] relative sm:w-[75px] sm:h-[75px] mb-[10px] h-[75px]">
            {useractive && (
              <div className="h-[17px] w-[17px] sm:border-[2px] absolute z-10 top-0 bg-blue-chatBlue rounded-[50%] border-white border-solid border-[3px] right-0 box-content sm:w-[17px] sm:h-[17px]"></div>
            )}
            <AvatarImage style={`h-[75px] sm:w-[80px] sm:h-[80px] w-[75px] `} />
          </div>
        <div className="font-[400] text-[16px] sm:text-[18px]">UserName</div>
        <div className="font-[400] text-[12px] sm:text-[15px]">User Status</div>
       <Link to='/user'>
        <button className="bg-gray-borderGray text-[12px] sm:text-[15px] py-[5px] mt-[10px] rounded px-[10px] font-[400] text-gray-inputsGray">Profilni ko’rish</button>
       </Link>
        </div>
        {/* Messages */}
        <div className="mt-[18px]">
          <div className="flex justify-center text-[14px] my-[10px] text-gray-lightGray">Today 10:00</div>
          <MassageMe value={'mess   age f ro m me sadfv db s uy dsac bsiud bvbsd uibnv adsbcil sdb vu ibsad uvib usabdvs udibvsiub'}/>
          <MassageMe value={'message  from me'}/>
          <MassageYou value={'message from you'}/>
          <MassageYou value={'message from mess   age f ro m me sadfv db s uy dsac bsiud bvbsd uibnv adsbcil sdb vu ibsad uvib usabdvs udibvsiubyou'}/>
          <div className="flex justify-center text-[14px] my-[10px] text-gray-lightGray">Today 19:00</div>
          <MassageMe value={'message from me'}/>
          <MassageYou>
            <img src={chemistrys} alt="" />
          </MassageYou>
          <MassageYou value={'message from you'}/>
        </div>
      </div>
      <div className="fixed z-50 flex justify-center bg-[white] pt-[5px] h-[100px] w-full bottom-[-40px]">
        <input
          className=" border-box mb-[100px]  w-full rounded-[100px] px-[32px] outline-none h-[50px] bg-gray-inputGray"
          placeholder="Type your message.."
        />
      </div>
    </>
  );
};

export default Chat;
